export const name = "AEAD.DECRYPT_STRING";
export const summary = `Uses the matching key from a keyset to decrypt a \`BYTES\` ciphertext into a \`STRING\` plaintext.`;
export const reference = `
## AEAD.DECRYPT_STRING

Uses the matching key from a keyset to decrypt a \`BYTES\` ciphertext into a \`STRING\` plaintext.

\`\`\`
AEAD.DECRYPT_STRING(keyset, ciphertext, additional_data)
\`\`\`

### Description

Like \`AEAD.DECRYPT_BYTES\`, but where \`additional_data\` is of type \`STRING\`.


### Return Data Type

\`STRING\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/aead_encryption_functions
`;
